import { ToggleButtonComponent } from './components/basic/toggle-button/toggle-button.component';
import { DecoratorDirective } from './directives/decorator.directive';

export { ToggleButtonComponent };
export type { ToggleButtonItem } from './components/basic/toggle-button/toggle-button.component';

// Import this barrel via a relative path to avoid Angular NG3004.

export const ToggleButton = [
  ToggleButtonComponent,
  DecoratorDirective
];
